import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    page: 1,
  },
}

const rentalContractsPageSlice = createSlice({
  name: 'rentalContractsPage',
  initialState,
  reducers: {
    updateFilters: (state, action) => {
      state.filters = action.payload
    },
    resetFilters: (state) => {
      state.filters = initialState.filters
    },
  },
})

export const { updateFilters, resetFilters } = rentalContractsPageSlice.actions
export default rentalContractsPageSlice.reducer


